import React, { useEffect } from "react";
import { connect } from "react-redux";
import { debug } from "../../utils";
import * as modalDataService from './modalDataService'
import * as validationService from './validationService'

//TODO fix onChange in useEffect
function ApiKeyField({ apiKey, anotherSectionActive, error }) {

    useEffect(() => {
        if (anotherSectionActive) {
            validationService.cleanValidation('apiKey');
            onChange('');
        } else {
            validationService.validateNotEmpty(apiKey, 'apiKey');
        }
        return () => validationService.cleanValidation('apiKey');
    }, [apiKey, anotherSectionActive])

    const onChange = (value) => modalDataService.changeApiKey(value)

    return (
        <div className="form-group">
            <div className="oct_form-group oct_form-sm">
                <label htmlFor="key">API Key <span className="modal-v2-required-mark">*</span></label>
                <input className={`form-control oct_field ${error && 'border-danger'}`}
                    id="key"
                    type={"password"}
                    value={apiKey}
                    placeholder="••••••••••••••••"
                    onChange={event => onChange(event.target.value)} />
            </div>
        </div>
    )
}

function mapStateToProps(state) {
    debug("ApiUrlField mapStateToProps", state);
    const addDeviceModal = state.addDeviceModal;
    const validation = state.validation;
    const anotherSectionActive = !!addDeviceModal.apiUsername || !!addDeviceModal.apiPassword
    return {
        apiKey: addDeviceModal.apiKey || '',
        error: validation.apiKey,
        anotherSectionActive
    }
}

export default connect(mapStateToProps)(ApiKeyField);
